import { TableCell } from '@mui/material';
import withStyles from '@mui/styles/withStyles';

export const StyledTableRow = withStyles(() => ({
  root: {
    paddingLeft: '24px',
    paddingRight: '24px',
  },
}))(TableCell);
